import { $api } from "services";
import { learnStore } from "./store";
import { TQuiz, TQuizForm } from "types/quiz";
import { notify } from "hooks/useToast/notify";
import { AxiosError } from "axios";

class LearnApi {
  private handleError(error: any) {
    if (error instanceof AxiosError) {
      const { response } = error;
      const message = response?.data?.message || 'Something went wrong';

      notify({
        type: 'error',
        meassage: message,
      });
    }
  }

  async getQuizzes() {
    const { setQuizes } = learnStore.getState();

    try {
      const url = '/api/learn-earn';
      const { data } = await $api.get<TQuiz[]>(url);
      setQuizes(data);

      return data;
    } catch (error) {
      console.error('Error fetching quizzes:', error);
      this.handleError(error);
      return null;
    }
  }

  async createQuiz(quiz: TQuizForm) {
    try {
      const url = '/api/learn-earn/quizzes/add';
      const { data } = await $api.post<TQuiz>(url, quiz);

      notify({
        type: 'success',
        meassage: 'Quiz created successfully',
      });

      return data;
    } catch (error) {
      console.error('Error creating quiz:', error);
      this.handleError(error);
      return null;
    }
  }

  async deleteQuiz(quizId: string) {
    const { quizes, setQuizes } = learnStore.getState();
    try {
      const url = `/api/learn-earn/quizzes/delete/${quizId}`;
      const { data } = await $api.delete<TQuiz>(url);
      
      const updatedQuizes = quizes.filter((quiz) => quiz.id !== quizId);
      setQuizes(updatedQuizes);
      
      notify({
        type: 'success',
        meassage: 'Quiz successfully deleted',
      });

      return data;
    } catch (error) {
      console.error('Error creating quiz:', error);
      this.handleError(error);
      return null;
    }
  }
}

export const learnService = new LearnApi();
